import { Truck, Zap, DollarSign, MapPin, Users, Heart } from "lucide-react";

const ITEMS = [
  {
    Icon: Truck,
    title: "Reliable Delivery",
    text: "Count on consistent, on-time heating oil delivery — especially when you need it most.",
  },
  {
    Icon: Zap,
    title: "Fast Service",
    text: "Quick response times, including emergency deliveries, so you're never left in the cold.",
  },
  {
    Icon: DollarSign,
    title: "Affordable Pricing",
    text: "Competitive rates with no hidden fees — quality service that fits your budget.",
  },
  {
    Icon: MapPin,
    title: "Local & Trusted",
    text: "Proudly serving Long Island with dependable, community-focused service.",
  },
  {
    Icon: Users,
    title: "Professional & Friendly Team",
    text: "Experienced drivers who are courteous, efficient, and safety-focused.",
  },
  {
    Icon: Heart,
    title: "Customer Satisfaction First",
    text: "We prioritize your comfort and work hard to earn your trust every time.",
  },
];

export default function WhyUs() {
  return (
    <section id="why" className="relative py-24 md:py-32 bg-white" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Flyer-style red banner header */}
        <div className="relative inline-block mb-12">
          <div className="bg-brand-red text-white px-6 py-3 border-2 border-brand-navy shadow-[6px_6px_0_#0A1128] -rotate-1">
            <div
              className="font-heading text-2xl sm:text-3xl tracking-tight"
              style={{ textShadow: "2px 2px 0 #0A1128" }}
            >
              WHY CHOOSE <span className="text-brand-gold">McFLY'S?</span>
            </div>
          </div>
        </div>

        <p className="text-brand-navy/80 leading-relaxed max-w-2xl text-lg mb-14">
          At McFly's Fuel, our mission is to deliver fast, reliable dispatch and fuel services to homeowners across Long Island, NY. We take pride in responding quickly, communicating clearly, and providing dependable service when it matters most. Whether it's a routine delivery or an emergency call, we're committed to keeping our community running with speed, professionalism, and care.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map(({ Icon, title, text }, i) => (
            <div
              key={title}
              className="group bg-white border-2 border-brand-navy p-7 transition-all shadow-[5px_5px_0_#0A1128] hover:shadow-[9px_9px_0_#D00017] hover:-translate-x-1 hover:-translate-y-1"
              data-testid={`why-item-${i}`}
            >
              <div className="w-11 h-11 flex items-center justify-center bg-brand-red text-white border-2 border-brand-navy mb-5">
                <Icon size={20} strokeWidth={2.25} />
              </div>
              <h3 className="font-heading text-xl mb-2 text-brand-navy">{title}</h3>
              <p className="text-sm text-brand-navy/75 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
